export default "__VITE_ASSET__CFYDOKOH__"